if (!window.console) {
	console = {
		log: function() {},
		info: function() {}
	};
}

var Util = {};
!function ($) {

	Util.removeFromArray = function(arr, what) {
		var what, a = arguments, L = a.length, ax;
		while (L > 1 && arr.length) {
			what = a[--L];
			while ((ax = $.inArray(what,arr)) !== -1) {
				arr.splice(ax, 1);
			}
		}
		return arr;
	};

	Util.checkSessionTimeout = function(xhr) {
		if(xhr && xhr.getAllResponseHeaders) {
			var headers = xhr.getAllResponseHeaders();
			var timeout = /LOGIN_PAGE:/.test(headers); 
			if(timeout) {
				location.href = "~/Login".resolveUrl();
			}
		}
	};

	Util.updateQueryStringParameter = function(uri, key, value) {
	  var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
	  separator = uri.indexOf('?') !== -1 ? "&" : "?";
	  if (uri.match(re)) {
	    return uri.replace(re, '$1' + key + "=" + value + '$2');
	  }
	  else {
	    return uri + separator + key + "=" + value;
	  }
	};

	Util.getQueryStringParameter = function(name) {
	    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
	    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	        results = regex.exec(location.search);
	    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};

	Util.deleteQueryStringParameter = function(url, key) {
		var urlparts= url.split('?');

		  if (urlparts.length>=2)
		  {
		      var urlBase=urlparts.shift(); //get first part, and remove from array
		      var queryString=urlparts.join("?"); //join it back up

		      var prefix = encodeURIComponent(key)+'=';
		      var pars = queryString.split(/[&;]/g);
		      for (var i= pars.length; i-->0;)               //reverse iteration as may be destructive
		          if (pars[i].lastIndexOf(prefix, 0)!==-1)   //idiom for string.startsWith
		              pars.splice(i, 1);
		      url = urlBase+'?'+pars.join('&');
		  }
		  return url;
	};
	
}(jQuery);